<template>
    <div class="main-section">
        
    <div class="content">

        <div class="navigation-bar">
            <div class="navigation-bar-menus">
                <ul>
                    <!-- <li><a class="sidebar-active">setup</a></li> -->
                    <li><router-link to="contacts">Contacts</router-link></li>
                    <li><router-link to="customforms" class="sidebar-active">Custom Forms</router-link></li>
                    <li><router-link to="autoresponse">Auto Response</router-link></li>
                    <!-- <li><router-link to="campaign">Campaign</router-link></li> -->
                    <li><router-link to="bulksms">BulkMan 1.2</router-link></li>
                </ul>
            </div>
        </div>
        <!-- eo page navigation bar -->

        <div class="main-content">
            
            <div class="quick-response content-here" id="qrs">
                <el-card>
                    <div class="custom-forms-lists">
                        <div class="contact-header">
                            <h1 class="heading-text">Send Bulk SMS <span @click="addCustomForm = true"><i class="glyphicon glyphicon-plus"></i> Create New Form</span></h1>
                        </div>

                        <div class="contact-table table-responsive">
                            <table class="table list-table spacing-table del-table">
                                <tbody class="custom-table">
                                    <template>
                                        <tr
                                        v-for="getallCustomForms in allCustomForms"
                                        :key="getallCustomForms.id">
                                            <td>{{getallCustomForms.formName}}</td>
                                            <td>
                                                <a
                                                @click="editContactDetailBtn()"
                                                class="el-icon-edit">
                                                </a>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-card>
            </div>
            <!-- eo quick response sms and history -->

        </div>
        <!-- end of main content -->

    </div>

    <div class="footer">
        <p>© ekghanti 2018</p>
    </div>

    <!-- dialogue for adding custom form -->
    <el-dialog title="Create Custom Form" :visible.sync="addCustomForm" width="50%">

        <div class="custom-forms">
            <el-form
            class="content-form"
            :label-position="'top'"
            label-width="100%"
            :model="addform"
            ref="addform">

                <el-form-item
                prop="form_name"
                label="Form Name"
                :rules="{required: true, message: 'This field can not be empty', trigger: 'blur'}">
                    <el-input v-model="addform.form_name"></el-input>
                </el-form-item>
                
                <!-- <div class="form-group">
                    <label for="">Form Name:</label>
                    <input
                    type="text"
                    class="form-control"
                    v-model="form_name">
                </div> -->

                <div class="added-form-detail">
                    <ul>
                        <li
                        :data-id="index"
                        v-for="(addcusform, index) in addform.Form"
                        :key="addcusform.id">

                            <div class="form-top">
                                <div class="form-left">
                                    <el-form-item
                                    label="Question Title"
                                    :prop="'Form.' + index + '.title'"
                                    :rules="{required: true, message: 'This field can not be empty', trigger: 'blur'}">
                                        <el-input v-model="addcusform.title"></el-input>
                                    </el-form-item>
                                </div>

                                <div class="form-right">
                                    <button @click.prevent="deleteRow(index)" class="el-icon-error del-btn text-muted"></button>
                                    
                                    <el-form-item
                                    label="Question Type">
                                        <el-select v-model="addcusform.selectedtype">
                                        <el-option label="Short Answer" value="input"></el-option>
                                        <el-option label="Paragraph" value="textarea"></el-option>
                                        <el-option label="Radio Button" value="radio"></el-option>
                                        <el-option label="Checkbox" value="checkbox"></el-option>
                                        <el-option label="Date" value="date"></el-option>
                                        <el-option label="Time" value="time"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <!-- eo form top -->

                            <div class="form-bottom">
                                <div>
                                    <p v-if="addcusform.selectedtype == 'input'" class="text-info">You have selected short text answer</p>
                                    <p v-else-if="addcusform.selectedtype == 'textarea'" class="text-info">You have selected long text answer</p>
                                    <p v-else-if="addcusform.selectedtype == 'date'" class="text-info">You have selected Date</p>
                                    <p v-else-if="addcusform.selectedtype == 'time'" class="text-info">You have selected Time</p>

                                    <div v-else-if="addcusform.selectedtype == 'radio' || addcusform.selectedtype == 'checkbox'">
                                        <el-form-item
                                        label="Options">
                                            <el-input
                                            type="textarea" 
                                            v-model="addcusform.option"></el-input>
                                            <p class="info text-info">Please use "," to separate options.</p>
                                        </el-form-item>
                                        
                                    </div>

                                    <p v-else class="text-danger">Please select Question Type</p>
                                </div>
                            </div>

                        </li>
                    </ul>
                </div>
            </el-form>
        </div>

        <div class="adddetail-forms">
            <a @click="addformdetail()"><i class="el-icon-plus"></i> Add Question</a>
        </div>

        <span slot="footer" class="dialog-footer" left>
            <el-button @click="addCustomForm = false">Cancel</el-button>
            <el-button type="primary" @click="submitForm('addform')">Save</el-button>
        </span>

    </el-dialog>

    </div>
</template>



<script>
import axios from 'axios'

export default {
    data() {
        return {
            addCustomForm: false,

            addform: {
                form_name: "",
                Form: [{
                    title: "",
                    selectedtype: "",
                    option: ""
                }]
            },

            allCustomForms: [
                {id:1, formName:"Form one"},
                {id:2, formName:"Form two"},
                {id:3, formName:"Form three"}
            ]
        }
    },
    methods: {
        addformdetail() {
            this.addform.Form.push({
                title: "",
                selectedtype: "",
                option: ""
            })
        },

        resetForm() {
            this.$refs[formName].resetFields();
        },

        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    alert('submit')
                    this.resetForm(formName)
                } else {
                    alert('form invalid')
                }
            })
        },

        deleteRow(index) {
            if (index !== -1) {
                this.addform.Form.splice(index, 1);
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subpages/customforms.vue